import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let option = useDataValue({
    context: 'option',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (option.isSelected || option.isDisabled) return
    return submit({ type: 'updatePatientOption', patient_option: option.id })
  }
}
